export enum OrderPurveyorState {
  DRAFT = 'draft',
  AWAITING_RECEIPT = 'awaiting_receipt',
  RECEIPT_IN_PROGRESS = 'receipt_in_progress',
  DISPUTED = 'disputed',
  COMPLETED = 'completed',
}

export const OrderPurveyorStateTranslation: Record<OrderPurveyorState, string> = {
  [OrderPurveyorState.DRAFT]: 'Brouillon',
  [OrderPurveyorState.AWAITING_RECEIPT]: 'En attente réception',
  [OrderPurveyorState.RECEIPT_IN_PROGRESS]: 'Réception en cours',
  [OrderPurveyorState.DISPUTED]: 'Litige',
  [OrderPurveyorState.COMPLETED]: 'Terminée',
};

export const OrderPurveyorStateSelects = (
  Object.keys(OrderPurveyorStateTranslation) as unknown as OrderPurveyorState[]
).map((orderPurveyorState) => ({
  value: orderPurveyorState,
  label: OrderPurveyorStateTranslation[orderPurveyorState],
}));
